import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-page container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8 text-center">Privacy Policy</h1>
      
      <div className="text-base text-white leading-relaxed">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
          <p className="mb-4">
            At Zahoot, we take your privacy seriously. This Privacy Policy explains how we collect, use, 
            disclose, and safeguard your information when you visit our website and use our services. 
            Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, 
            please do not access the site.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
          <p className="mb-4">
            We may collect personal information that you voluntarily provide to us when you register on the 
            website, express an interest in obtaining information about us or our products and services, 
            participate in activities on the website, or otherwise contact us.
          </p>
          <p className="mb-4">
            The personal information that we collect depends on the context of your interactions with us and 
            the website, the choices you make, and the products and features you use. The personal information 
            we collect may include the following:
          </p>
          <ul className="list-disc pl-6 mt-2 mb-4 space-y-2">
            <li>Name and contact data</li>
            <li>Credentials</li>
            <li>Payment data</li>
            <li>Location data</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Cookies and Tracking Technologies</h2>
          <p className="mb-4">
            We use cookies and similar tracking technologies to track activity on our website and store certain information. 
            Cookies are files with a small amount of data which may include an anonymous unique identifier. 
            Cookies are sent to your browser from a website and stored on your device.
          </p>
          <p className="mb-4">
            We use different types of cookies for different purposes:
          </p>
          <ul className="list-disc pl-6 mt-2 mb-4 space-y-2">
            <li><strong>Necessary cookies:</strong> These are essential for the website to function properly and cannot be switched off in our systems.</li>
            <li><strong>Analytics cookies:</strong> These help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
            <li><strong>Marketing cookies:</strong> These are used to track visitors across websites to enable us to display relevant and engaging advertisements.</li>
            <li><strong>Preference cookies:</strong> These enable the website to remember information that changes the way the website behaves or looks, like your preferred language or the region you are in.</li>
          </ul>
          <p className="mb-4">
            You can set your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
          </p>
          <p className="mb-4">
            When you first visit our website, you will be presented with a cookie consent banner that allows you to choose 
            which types of cookies you allow us to use. You can change your preferences at any time by clearing your cookies 
            and visiting our website again.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
          <p className="mb-4">
            We use personal information collected via our website for a variety of business purposes described 
            below. We process your personal information for these purposes in reliance on our legitimate business 
            interests, in order to enter into or perform a contract with you, with your consent, and/or for 
            compliance with our legal obligations.
          </p>
          <ul className="list-disc pl-6 mt-2 mb-4 space-y-2">
            <li>To facilitate account creation and authentication</li>
            <li>To deliver services to the user</li>
            <li>To respond to user inquiries/offer support to users</li>
            <li>To send administrative information</li>
            <li>To send marketing and promotional communications</li>
            <li>For analytics and improvements to our website</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Third-Party Websites</h2>
          <p className="mb-4">
            Our website may contain links to third-party websites and applications of interest, including 
            advertisements and external services, that are not affiliated with us. Once you have used these 
            links to leave our website, any information you provide to these third parties is not covered by 
            this Privacy Policy, and we cannot guarantee the safety and privacy of your information.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="mb-4">
            If you have questions or comments about this Privacy Policy, please contact us at:
          </p>
          <p className="font-medium mt-2 mb-4">
            Email: support@zahoot.ai<br />
            Phone: +44 121 630 0000
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Changes to This Privacy Policy</h2>
          <p className="mb-4">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting 
            the new Privacy Policy on this page and updating the "Last Updated" date at the top. You are 
            advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 